<template>
  <div ref="root" class="dropdown bs-dropdown">
    <button
      type="button"
      class="btn dropdown-toggle"
      :class="buttonClass"
      aria-haspopup="true"
      :aria-expanded="open ? 'true' : 'false'"
      @click="toggle"
    >
      <slot name="button"></slot>
    </button>
    <!-- text-left: se renderiza dentro de #app, que centra el texto (App.vue) -->
    <div
      v-if="open"
      class="dropdown-menu show text-left"
      :class="[{ 'dropdown-menu-right': right }, menuClass]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
// eslint-plugin-vue 6.x (anterior a <script setup>) no ve que estos bindings
// se usan en el template. Quitar el disable cuando se actualice el tooling.
/* eslint-disable no-unused-vars */
// Dropdown con las clases de Bootstrap 4, sin Bootstrap-Vue ni el JS de Bootstrap (requiere
// jQuery, que no está cargado). El panel puede contener controles: solo se cierra con el
// botón, Esc o un clic fuera.
import { onBeforeUnmount, ref } from "vue";

defineProps({
  // Clases del botón, p. ej. "btn-primary btn-sm"
  buttonClass: {
    type: String,
    default: "btn-primary",
  },
  menuClass: {
    type: String,
    default: "",
  },
  // Alinea el panel al borde derecho del botón
  right: {
    type: Boolean,
    default: false,
  },
});

const root = ref(null);
const open = ref(false);

function onMousedown(event) {
  if (root.value && !root.value.contains(event.target)) setOpen(false);
}

function onKeydown(event) {
  if (event.key === "Escape") setOpen(false);
}

function setOpen(value) {
  if (value === open.value) return;
  open.value = value;
  const method = value ? "addEventListener" : "removeEventListener";
  document[method]("mousedown", onMousedown);
  document[method]("keydown", onKeydown);
}

function toggle() {
  setOpen(!open.value);
}

onBeforeUnmount(() => setOpen(false));
</script>
